import { CREW_FILTER, MOBILE_STATUS_FILTER } from "../common/common.filters";

export const COMMUNICATION_LIST_FILTERS = {
    crew: CREW_FILTER,
    mobile_status: MOBILE_STATUS_FILTER,
};
